// extracted by mini-css-extract-plugin
export default {"products_container":"results_products_container__NS2SI"};